import { createSlice } from '@reduxjs/toolkit';
import { timesheetActs } from '../action';
import {
  GroupingTimesheetDataItem,
  TimeSheetDataItem,
} from '../../../../types/models/timesheet';
import { PaginationType } from '@nxsys/types/models/Common';
import { GetListTimesheetsParams } from '../type';

export interface TimesheetsState {
  timesheetsData: {
    list: TimeSheetDataItem[];
    pagination: PaginationType;
    salariedEmployees: any[];
    totalDocs: number;
    success: boolean;
    queryParams: GetListTimesheetsParams | null;
  };
  groupingTimesheetsData: {
    list: GroupingTimesheetDataItem[];
  };
  loading: boolean;
}

export const initialState: TimesheetsState = {
  timesheetsData: {
    list: [],
    pagination: {
      current: 0,
      pageSize: 20,
      totalDocs: 0,
    },
    salariedEmployees: [],
    totalDocs: 0,
    success: false,
    queryParams: null,
  },
  groupingTimesheetsData: {
    list: [],
  },
  loading: false,
};

const timesheetsSlice = createSlice({
  name: 'timesheetsSlice',
  initialState: initialState,
  reducers: {
    clearTimesheetsData: (state) => {
      state.timesheetsData = initialState.timesheetsData;
    },
    clearGroupingTimesheetsData: (state) => {
      state.groupingTimesheetsData = initialState.groupingTimesheetsData;
    },
  },
  extraReducers: (builder) => {
    //timesheets
    builder.addCase(timesheetActs.getListTimesheets.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      timesheetActs.getListTimesheets.fulfilled,
      (state, action) => {
        state.loading = false;
        state.timesheetsData.pagination = action.payload.pagination;
        state.timesheetsData.list = action.payload.data;
        state.timesheetsData.salariedEmployees =
          action.payload.salariedEmployees;
        state.timesheetsData.totalDocs = action.payload.totalDocs;
        state.timesheetsData.success = action.payload.success;
        state.timesheetsData.queryParams = action.payload.queryParams;
      },
    );
    builder.addCase(timesheetActs.getListTimesheets.rejected, (state) => {
      state.loading = false;
    });

    //bureau timesheets
    builder.addCase(
      timesheetActs.getListBureauTimesheets.pending,
      (state) => {
        state.loading = true;
      },
    );
    builder.addCase(
      timesheetActs.getListBureauTimesheets.fulfilled,
      (state, action) => {
        state.loading = false;
        state.timesheetsData.pagination = action.payload.pagination;
        state.timesheetsData.list = action.payload.data;
        state.timesheetsData.salariedEmployees =
          action.payload.salariedEmployees;
        state.timesheetsData.totalDocs = action.payload.totalDocs;
        state.timesheetsData.success = action.payload.success;
        state.timesheetsData.queryParams = action.payload.queryParams;
      },
    );
    builder.addCase(
      timesheetActs.getListBureauTimesheets.rejected,
      (state) => {
        state.loading = false;
      },
    );

    //grouping timesheets
    builder.addCase(
      timesheetActs.getListGroupingTimesheets.pending,
      (state) => {
        state.loading = true;
      },
    );
    builder.addCase(
      timesheetActs.getListGroupingTimesheets.fulfilled,
      (state, action) => {
        state.loading = false;
        state.groupingTimesheetsData.list = action.payload.data;
      },
    );
    builder.addCase(
      timesheetActs.getListGroupingTimesheets.rejected,
      (state) => {
        state.loading = false;
      },
    );

    //grouping timesheets bureau
    builder.addCase(
      timesheetActs.getListGroupingTimesheetsBureau.pending,
      (state) => {
        state.loading = true;
      },
    );
    builder.addCase(
      timesheetActs.getListGroupingTimesheetsBureau.fulfilled,
      (state, action) => {
        state.loading = false;
        state.groupingTimesheetsData.list = action.payload.data;
      },
    );
    builder.addCase(
      timesheetActs.getListGroupingTimesheetsBureau.rejected,
      (state) => {
        state.loading = false;
      },
    );
  },
});

export const timesheetsReducer = timesheetsSlice.reducer;
export const timesheetsAction = {
  ...timesheetsSlice.actions,
  ...timesheetActs,
};
